// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"219":"component---src-pages-dn-42-jsx","230":"component---src-pages-index-jsx"}[chunkId] + "-" + {"219":"55ffe61cc151a3e41176","230":"9a338b4759e0151dd8ea"}[chunkId] + ".js";
};